<script lang="js">
  const statusColors = {
    error: 'red accent-2',
    warning: 'orange lighten-2',
    ok: 'green lighten-3',
    future: 'brown lighten-5'
  };

  const backgroundColors = {
    default: 'white',
    weekend: 'blue-grey lighten-4',
    publicHoliday: 'light-blue lighten-4',
    userHoliday: 'cyan lighten-4',
    sickLeave: 'teal lighten-3',
    otherAbsence: 'purple lighten-4',
    error: 'red accent-1',
    warning: 'orange lighten-3'
  };

  export default {
    data() {
      return {
      }
    },

    methods: {
      getStatusColor(status) {
        return statusColors[status];
      },

      getBackgroundColor(status) {
        return backgroundColors[status];
      },

      calcItemBackgroundColor(item) {
        return item.errors && item.errors.length > 0 ? backgroundColors['error'] :
          (item.warnings && item.warnings.length > 0 ? backgroundColors['warning'] : "");
      },

      getDayTypeIcon(day) {
        if (day.isHomeOffice) {
          return 'mdi-home';
        } else if (day.type == global.DAY_TYPE.URLAUB.code) {
          return 'mdi-airplane';
        } else if (day.type == global.DAY_TYPE.KRANKENSTAND.code) {
          return 'mdi-emoticon-sick-outline'
        } else if (day.type == global.DAY_TYPE.FEIERTAG.code) {
          return 'mdi-star';
        } else if (day.type >= global.DAY_TYPE.SONSTIGE_ABWESENHEITEN.code) {
          return 'mdi-information-outline';
        } else {
          return '';
        }
      },

      getDayType(day) {
        if (day.type == global.DAY_TYPE.FEIERTAG.code) {
          return 'publicHoliday';
        } else if (day.type == global.DAY_TYPE.URLAUB.code) {
          return 'userHoliday';
        } else if (day.type == global.DAY_TYPE.KRANKENSTAND.code) {
          return 'sickLeave';
        } else if (day.type >= global.DAY_TYPE.SONSTIGE_ABWESENHEITEN.code) {
          return 'otherAbsence';
        } else if (day.isWeekend) {
          return 'weekend';
        } else {
          return 'default';
        }
      },

      getAbsenceTitle(day) {
        if (day.type == global.DAY_TYPE.STANDARD.code) {
          return day.isHomeOffice ? 'HomeOffice' : undefined;
        }

        const scheduleConfigKey = Object.keys(global.DAY_TYPE).find(scheduleKey => {
          return day.type == global.DAY_TYPE[scheduleKey].code;
        });

        if (!scheduleConfigKey) {
          return undefined;
        }

        return global.DAY_TYPE[scheduleConfigKey].title;
      }
    },
  };
</script>